import React from 'react'
import { Route, Switch } from 'react-router-dom'
import RedirectRoute from './utilities/RedirectRoute'
import asyncComponent from '../utils/AsyncComponent'

// base containers
const Login = asyncComponent(() => import('../components/auth/login/Login'))
const PagesRouters = asyncComponent(() => import('./PagesRouters'))


const isLogged = () => {
  const token = localStorage.getItem('token')
  return !!token
}

const RootRouter = () => (
  <Route>
    <Switch>

      <RedirectRoute
        path="/login"
        component={Login}
        if={!isLogged()}
        redirect="/"
      />

      <RedirectRoute
        path="/"
        component={PagesRouters}
        if={isLogged()}
        redirect="/login"
      />

    </Switch>
  </Route>
)
export default RootRouter



// WEBPACK FOOTER //
// ./src/routers/RootRouter.js